import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";
const useStyles = createUseStyles({
  contentMain: {
    overflow: "hidden",
    height: "var(--app-vh)",
    // On mobile the Sidebar content area is the scroller; a locked 100vh here
    // clipped the page instead.
    "@media (max-width:899.95px)": {
      overflow: "visible",
      height: "auto",
      minHeight: "var(--app-vh)",
    },
  },
  containerHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "12px",
    padding: "15px 0px 15px 0px",
    // The title must be free to shrink, otherwise the nowrap action button is
    // pushed outside the viewport on narrow screens.
    "& > div:first-child": { minWidth: 0, flex: "1 1 auto" },

    "@media (max-width:599.95px)": {
      flexDirection: "column",
      alignItems: "stretch",
      gap: "10px",
      padding: "10px 0px",
      // 30px Poppins-Black ate three lines on a phone.
      "& > div:first-child": {
        flex: "0 0 auto",
        fontSize: "22px",
        lineHeight: "28px",
      },
      // Full-width CTA stacked under the title.
      "& .MuiButton-root": { width: "100% !important" },
    },
  },
  vehiculeRoot: {
    padding: "30px clamp(16px, 3vw, 30px)",
    overflowY: "auto",
    overflowX: "hidden",
    height: "var(--app-vh)",
    minWidth: 0,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    backgroundColor: colors.bgcolor,
    // Let the table card fill remaining height so the paginator stays visible.

    "& > div:last-child": { flex: "1 1 auto", minHeight: 0, minWidth: 0 },

    "@media (max-width:899.95px)": {
      paddingTop: "68px",
      // Let the page grow and scroll as one document instead of nesting a
      // second 100vh scroller inside the Sidebar's own scroller.
      height: "auto",
      minHeight: "var(--app-vh)",
      overflowY: "visible",
      "& > div:last-child": { flex: "0 0 auto" },
    },
  },
  buttonsCollab: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: "15px",
    width: "100%",
  },

  /** Roster counts above the table. */
  rosterSummary: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "16px",
    margin: "4px 0 12px",
    fontSize: "13px",
    color: "#6b6b6b",
  },
  summaryPending: {
    color: "#7a4f01",
    fontWeight: 600,
  },
  summaryExpired: {
    color: "#b71c1c",
    fontWeight: 600,
  },
});

export default useStyles;
